import React from 'react';
import { TextOnlyTooltip } from 'components/ui/TextOnlyTooltip/TextOnlyTooltip';
import { ButtonProps } from '@material-ui/core';
import ButtonUi from '@material-ui/core/Button';
import { ETooltipPlacment } from 'common/types/common.types';
import { useStyles } from './buttonTheme';
import { LoadingElement } from './LoadingElement/LoadingElement';

interface IProp {
  loading?: boolean;
  tooltip?: string;
  tooltipPlacment?: ETooltipPlacment;
}

export const Button: React.FC<IProp & ButtonProps> = ({
  children,
  loading = false,
  disabled,
  classes,
  tooltip,
  tooltipPlacment,
  ...rest
}) => {
  const classesLocal = useStyles({ loading });

  return (
    <TextOnlyTooltip title={tooltip || ''} placement={tooltipPlacment || 'bottom'} leaveTouchDelay={1}>
      <ButtonUi disabled={loading || disabled} classes={{ ...classesLocal, ...classes }} {...rest}>
        {loading && <LoadingElement />}
        <span className='MuiButton-label-text'>{children}</span>
      </ButtonUi>
    </TextOnlyTooltip>
  );
};
